<template>
	<div class="d-flex justify-content-end message_user animate slideInUp">
		<div class="message-box_user" v-html="chatResponse" :style="data && data.key == 'email' ? 'text-transform: lowercase !important;' : '' ">  
		</div>
	</div>
</template>

<script>
	/**
	 *  Import dependencies & event bus
	 */
	import store from '../../store'
	import { mapState, mapActions } from 'vuex'
	import { EventBus } from '../../event-bus'
	import Cookies from 'js-cookie'
	import * as appConfigs from '../../configs'
	import axios from 'axios'
    import queryString from 'query-string'
	import { includes } from 'lodash'

	/**
	 * Import local components
	 */


	export default {
        props: [
            'message','data'
        ],
		store,
	   components: {},
		mounted() {
			this.initializeReminderToken();
		},

		computed: {
			...mapState({
				configs: state => state.configs,
				orderId: state => state.orderId, // 3026
				pendingOrder: state => state.pendingOrder,
				selectedOccupation: state => state.selectedOccupation,
				step: state => state.step,
				prevStep: state => state.prevStep,
				unavailableOccupations: state => state.unavailableOccupations,
			}),

			showSidebar () {
				return this.step >= 5
			},

			showInReferral () {
				return (
					Cookies.get('convertFromReferral') != this.pendingOrder.id &&
					this.pendingOrder.in_referral
				)
			},

			showUnavailableOccupation () {
				if (
					this.step >= 3 &&
					this.prevStep >= 2 &&
					(
						includes(this.unavailableOccupations, this.pendingOrder.occupation_id) ||
						this.pendingOrder.current_annual_revenue > 2500000 ||
						this.pendingOrder.status == 'HS'
					)
				) {

					// Cleaning the pendingOrderId because
					// after the thank you page, user should be able to fill out the form again
					Cookies.remove('pendingOrderId')
					return true;
				}

				return false;
			},
			chatResponse(){
				var message = this.message;
				if(this.data != undefined && this.data.label != undefined){
					if(this.data.label == "turnover" || this.data.label == "annual_revenue"){
						message = this.formatCurrency(message);
					}

					if(this.data.key == "limits_required" ){
						message = message.replace('000000', ' Million');
					}
					
					if(typeof message !== 'string' ){
						message = '<img src="'+this.chatImageGifUrl+'" width="30px" alt="Chatbot | PLI" height="auto"/>';
					}
				}

				return message;
			},
			chatImageGifUrl() {
				return appConfigs.apiDomain + "images/chat-loader.svg";
			},
		},

        methods: {
            //check if reminder token exists, if it is then need to fire an ajax request to
            //check if the token is valid, then set the cookie, otherwise no further action
            //needed to be taken
            initializeReminderToken(){
                let vm = this
                let queryStringObj = queryString.parse(location.search)
                if('reminder_token' in queryStringObj)
                {
                    //if any error/exception occur, do not need to do anything, so axios do not need
                    //catch to handle error
                    axios.get(appConfigs.decryptReminderTokenUrl, {
                        params: queryStringObj
                    }).then((response) => {
                        if(response.data.status == 'error')
                        {
                            Cookies.remove('pendingOrderId')
                            vm.$store.commit('setError', { error: response.data.message })
                        }
                        else if(response.data.status == 'success')
                        {
					        Cookies.set('pendingOrderId', response.data.pending_order_id)
                        }

                    }).catch(error => {
						Cookies.remove('pendingOrderId')
                        vm.$store.commit('setError', { error: 'Invalid token error' })
                    })
                }
			},
			formatCurrency(value){
				var parts = value.toString().split(".");
				parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				value = "$" + parts.join(".");
				return value;
			}
        }
	}
</script>

<style>
.message_user{
    padding: 10px;
}

.message-box_user{
    border: 2px solid #bce4f9;
    background-color: #bce4f9;
    padding: 10px;
    color: #000;
    margin-top:3px;
	border-radius: 15px 0px 15px 15px;
	width: fit-content;
	max-width: 60%;
	text-align: right;
	font-size: 16px;
	line-height: 26px;
	text-transform: capitalize !important;
}
@media screen and (max-width: 768px) {
 	.message_user{
		padding: 5px !important;
		max-width: 100%;
	}
	.message-box_user{
		max-width: 100%;
		font-size: 14px;
	}
}
</style>
    